module.exports = __webpack_public_path__ + "img/marcas-todos-los-productos2.751843a3.png";